import { Injectable, inject } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { CustomService } from '@/shared/services/custom.service';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { HistoricoRequest, MedicoHistoricoCancelamentoRequest, MedicoInscricaoSecundariaRequest } from '@/core/api/sicom-api/registro/medico/historico/historico.model';
import { HistoricoService } from '@/core/api/sicom-api/registro/medico/historico/historico.service';

@Injectable({
    providedIn: 'root'
})
/** Fachada de histórico de situação e inscrições secundárias. */
export class HistoricoFeatureService extends CustomService {
    private readonly historicoCore = inject(HistoricoService);

    /**
     * Histórico da situação do médico.
     * GET /api/v1/cadastro/medico/historico/consulta
     * Envia PessoaRequest via query string com chaves planas (id, uf) seguindo o padrão do RequestBuilder.
     */
    buscar(params: Pessoa): Observable<HistoricoRequest[]> {
        // Delegamos ao serviço core gerado, que usa RequestBuilder e mantém padrão de headers/Accept
        return this.historicoCore.buscar(params).pipe(catchError(this.handleError));
    }

    /**
     * Histórico de inscrições secundárias do médico.
     * GET /api/v1/cadastro/medico/historico/consulta-secundarias
     * Envia PessoaRequest via query string com chaves planas (id, uf) seguindo o padrão do RequestBuilder.
     */
    buscarSecundarias(params: Pessoa): Observable<HistoricoRequest[]> {
        return this.historicoCore.buscarSecundarias(params).pipe(catchError(this.handleError));
    }

    /**
     * Inserir/atualizar data de cancelamento no histórico do médico.
     * Encaminha para o serviço core que executa POST /api/v1/cadastro/medico/historico/cancelamento.
     * Retorna true quando atualizado (204) e false quando não encontrado (404).
     */
    atualizarCancelamento(payload: MedicoHistoricoCancelamentoRequest): Observable<boolean> {
        return this.historicoCore.atualizarCancelamento(payload).pipe(catchError(this.handleError));
    }

    /**
     * Adiciona uma inscrição secundária para o médico informado.
     * POST /api/v1/cadastro/medico/historico/inscricao-secundaria
     * Retorna true quando criado (201) e false quando conflito/dados inválidos (409).
     */
    adicionarInscricaoSecundaria(pessoa: Pessoa, body: MedicoInscricaoSecundariaRequest): Observable<boolean> {
        return this.historicoCore.adicionarInscricaoSecundaria(pessoa, body).pipe(catchError(this.handleError));
    }
}
